import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastDelivery: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFastDelivery"><Path d="M12.5 20.5H20.5V3.5H3.5V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 3.5V9.5H15.5V3.5" stroke="currentColor"/><Path d="M1.5 17.5H6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 20.5H8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 14.5L8.5 14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFastDelivery;
